import _classPrivateFieldInitSpec from "@babel/runtime/helpers/classPrivateFieldInitSpec";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet2";
import _classPrivateFieldSet from "@babel/runtime/helpers/classPrivateFieldSet2";
import { symbolOfAttributeHasBeenSet, symbolOfMarkAttributeHasBeenSet, symbolOfStopAttributeChangedCallback } from "./internal/symbols.js";
var _hasRequestedRender = /*#__PURE__*/new WeakMap();
var _connectedCallbackCalled = /*#__PURE__*/new WeakMap();
var _attributeChangedCallbackStopped = /*#__PURE__*/new WeakMap();
var _attributesBeenSet = /*#__PURE__*/new WeakMap();
export class NextElement extends HTMLElement {
  constructor() {
    super(...arguments);
    _classPrivateFieldInitSpec(this, _hasRequestedRender, false);
    _classPrivateFieldInitSpec(this, _connectedCallbackCalled, false);
    _classPrivateFieldInitSpec(this, _attributeChangedCallbackStopped, false);
    _classPrivateFieldInitSpec(this, _attributesBeenSet, new Set());
  }
  /**
   * When render a custom element as parsed DOM, it is already connected in the
   * first place. The attributes are set while isConnected is true, which will
   * trigger a render request, and then before the next micro-task, the
   * `connectedCallback` will be called, which will trigger an immediate render.
   * Thus we would see two calls of render. So we manually set a mark of whether
   * the `connectedCallback` is actually get called, to prevent a trigger of
   * render request during attributes initialization before `connectedCallback`.
   */
  _markConnectedCallbackCalled() {
    _classPrivateFieldSet(_connectedCallbackCalled, this, true);
  }
  connectedCallback() {
    this._markConnectedCallbackCalled();
    this._render();
  }
  [symbolOfAttributeHasBeenSet](name) {
    return _classPrivateFieldGet(_attributesBeenSet, this).has(name);
  }
  [symbolOfMarkAttributeHasBeenSet](name) {
    _classPrivateFieldGet(_attributesBeenSet, this).add(name);
  }

  /** Whether to process attributeChangedCallback. */
  [symbolOfStopAttributeChangedCallback](value) {
    _classPrivateFieldSet(_attributeChangedCallbackStopped, this, value);
  }

  /** @internal */
  attributeChangedCallback(name, old, value) {
    _classPrivateFieldGet(_attributesBeenSet, this).add(name);
    if (!_classPrivateFieldGet(_attributeChangedCallbackStopped, this) && old !== value) {
      const attrRef = this.constructor.__attributeReflections.get(name);
      assertAttributeIsReflected(attrRef, name);
      const propValue = attrRef.converter.fromAttribute(value, attrRef.type);
      this[attrRef.property] = propValue;
    }
  }

  /**
   * Request a render in the next micro-task. This ensures multiple properties
   * or attributes will trigger a render once in a batch.
   */
  _requestRender() {
    // If the element is not connected,
    // let `connectedCallback()` do the job of calling _render.
    if (this.isConnected && _classPrivateFieldGet(_connectedCallbackCalled, this) && !_classPrivateFieldGet(_hasRequestedRender, this)) {
      _classPrivateFieldSet(_hasRequestedRender, this, true);
      Promise.resolve().then(() => {
        _classPrivateFieldSet(_hasRequestedRender, this, false);
        this._render();
      });
    }
  }
}
_defineProperty(NextElement, "styleTexts", void 0);
_defineProperty(NextElement, "shadowOptions", void 0);
_defineProperty(NextElement, "__attributeReflections", void 0);
_defineProperty(NextElement, "__tagName", void 0);
function assertAttributeIsReflected(attrRef, name) {
  // istanbul ignore next
  if (process.env.NODE_ENV === "development" && !attrRef) {
    throw new Error(`Attribute [${name}] is not reflected`);
  }
}
//# sourceMappingURL=NextElement.js.map